import React from 'react';
import ErrorMessage from '../../shared/components/ErrorMessage';

/**
 * @typedef {object} ErrorsContainerProps
 * @property {Array<*>} validationErrors
 */

/**
 * @param {ErrorsContainerProps} props
 */
const ErrorsContainer = props => {
  const { validationErrors } = props;
  if (validationErrors.length === 0) {
    return null;
  }

  return (
    <div className='errors-container' data-testid='errors-container'>
      {validationErrors.map((ve, idx) => (
        <ErrorMessage key={idx} message={ve.message} className='error-message' />
      ))}
    </div>
  );
};

export default ErrorsContainer;
